var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleMeet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.99998V13.3333H12.3333V7.99998H7Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.33333V13L5.66667 13.3333L7.33333 13V8.33333L5.66667 8L4 8.33333Z",
    fill: "#1E88E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 10.6666V15.3333C15.3333 15.8856 14.8857 16.3333 14.3333 16.3333H7.33333L7 14.6666L7.33333 13H12V10.6666L13.6667 10.3333L15.3333 10.6666Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 6V10.6667H12V8.33333H7.33333L7 6.66667L7.33333 5H14.3333C14.8857 5 15.3333 5.44767 15.3333 6Z",
    fill: "#FBC02D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 13V16.3333H5C4.44767 16.3333 4 15.8857 4 15.3333V13H7.33333Z",
    fill: "#1565C0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 5V8.33333H4L7.33333 5Z",
    fill: "#E53935"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 10.6667L15.3333 13.4833L12 10.6667L15.3333 7.85001L15.6667 10.6667Z",
    fill: "#2E7D32"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 6.03666V15.2967C18.3334 15.5767 18.0067 15.7333 17.79 15.5567L15.3334 13.4833V7.84999L17.79 5.77666C18.0067 5.59999 18.3334 5.75666 18.3334 6.03666Z",
    fill: "#4CAF50"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMeet);
export default __webpack_public_path__ + "static/media/GoogleMeet.9af1140301a29977b509aa89493e6080.svg";
export { ForwardRef as ReactComponent };